<template>
  <div class="filter-section">
    <div 
      class="d-flex align-center mb-3 cursor-pointer"
      @click="showFilters = !showFilters"
    >
      <h2 class="text-subtitle-1 font-weight-medium text-grey-darken-1">
        <v-icon
          icon="mdi-filter-variant"
          size="20"
          class="me-2"
        />
        Filter by Tag
        <span 
          v-if="modelValue.length" 
          class="text-primary text-body-2"
        >
          ({{ modelValue.length }} selected)
        </span>
      </h2>
      <v-spacer />
      <v-btn
        v-if="modelValue.length"
        variant="text"
        density="comfortable"
        color="grey-darken-1"
        size="small"
        prepend-icon="mdi-close"
        class="me-2"
        @click.stop="$emit('update:modelValue', [])"
      >
        Clear Filters
      </v-btn>
      <v-icon
        :icon="showFilters ? 'mdi-chevron-up' : 'mdi-chevron-down'"
        color="grey-darken-1"
      />
    </div>

    <v-expand-transition>
      <div v-show="showFilters">
        <v-chip-group
          :model-value="modelValue"
          column
          multiple
          class="filter-chips"
          show-arrows
          @update:model-value="$emit('update:modelValue', $event)"
        >
          <v-chip
            v-for="tag in availableTags"
            :key="tag.id"
            filter
            variant="tonal"
            :value="tag.id"
            class="filter-chip"
          >
            {{ tag.name }}
          </v-chip>
        </v-chip-group>
      </div>
    </v-expand-transition>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import type { ITag } from '@/models/tag/tag.types'

interface Props {
  modelValue: number[]
  availableTags: ITag[]
}

defineProps<Props>()
defineEmits<{
  'update:modelValue': [value: number[]]
}>()

const showFilters = ref(false)
</script>

<style scoped>
.filter-section {
  padding: 16px;
  background-color: rgb(var(--v-theme-surface));
  border: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
  border-radius: 8px;

  .cursor-pointer {
    cursor: pointer;
    user-select: none;
  }
}

.filter-chips {
  :deep(.v-chip) {
    &.v-chip--selected {
      background-color: rgba(var(--v-theme-primary), 0.12);
      color: rgb(var(--v-theme-primary));
      font-weight: 500;
    }

    &:not(.v-chip--selected) {
      background-color: rgb(var(--v-theme-surface));
      color: rgb(var(--v-theme-on-surface));
      border: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
    }

    &:hover:not(.v-chip--selected) {
      background-color: rgba(var(--v-theme-on-surface), 0.04);
    }
  }
}
</style> 